import { createFileRoute } from "@tanstack/react-router"
import { useCallback } from "react"
import {
	LeadsPage,
	leadsSearchSchema,
	type UpdateLeadsRouteSearch,
} from "@/pages/leads"

function LeadsRoutePage() {
	const search = Route.useSearch()
	const navigate = Route.useNavigate()
	const updateSearch = useCallback(
		(patch: Parameters<UpdateLeadsRouteSearch>[0]) => {
			void navigate({
				search: (previous) => ({ ...previous, ...patch }),
				replace: true,
			})
		},
		[navigate],
	)

	return <LeadsPage routeSearch={search} onRouteSearchChange={updateSearch} />
}

export const Route = createFileRoute("/(analytics)/leads")({
	validateSearch: (search) => leadsSearchSchema.parse(search),
	component: LeadsRoutePage,
})
